/* eslint-disable camelcase */
import * as pc from 'playcanvas';
import {AssetLoader} from './AssetLoader';
import {MaterialManager} from './MaterialManager';
import {PlantScene} from './PlantScene';
import {Component_Slither} from './components/Component_Slither';
import {Component_Fly} from './components/Component_Fly';
import {IRWN} from './IRWN';
import gsap from 'gsap';
const CreatureManager = {
  creatureMaterial: null,


  //------------------------------------> FLYING CREATURES
  lastFlyingTypeSpawned: 0,
  flyingCreatureScale: 1.5,
  flyingCreature_spawnTimer_min: 0,
  flyingCreature_spawnTimer_max: 15,


  // activeCreatures_fly: [],
  // occupiedLandingZones: [],
  creatureList_fly: [
    {
      name: 'bee7',
      flapRateScalar: 120,
      flapRateRange: 0.25,
      flapRateChangeRate: 0.75,
      accX: 0.0002,
      accY: 0.0002,
      accZ: 0.0005,
      turnRate: 0.02,
      scale: 0.75,
    },
    {
      name: 'fly2',
      flapRateScalar: 120,
      flapRateRange: 0.25,
      flapRateChangeRate: 0.75,
      accX: 0.0002,
      accY: 0.0002,
      accZ: 0.0005,
      turnRate: 0.02,
      scale: 0.75,
    },
    {
      name: 'wasp6',
      flapRateScalar: 120,
      flapRateRange: 0.25,
      flapRateChangeRate: 0.75,
      accX: 0.0002,
      accY: 0.0002,
      accZ: 0.0005,
      turnRate: 0.02,
      scale: 0.5,
    },
    {
      name: 'nightFly',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'dragonFly',
      flapRateScalar: 130,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.45,
      accX: 0.00025,
      accZ: 0.00025,
      accY: 0.00025,
      turnRate: 0.02,
      scale: 0.8,
    },
    {
      name: 'butterfly1',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'butterfly4',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'cabbageWhite',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'greenFlying',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'moth12',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'nightButterfly',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'whiteButterfly',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'whiteButterfly5',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0002,
      turnRate: 0.01,
      scale: 1,
    },
    {
      name: 'yellowInsect',
      flapRateScalar: 50,
      flapRateRange: 0.4,
      flapRateChangeRate: 0.3,
      accX: 0.0005,
      accY: 0.0005,
      accZ: 0.0001,
      turnRate: 0.01,
      scale: 1,
    },
  ],

  // creatureList_fly: [
  //     'bee7.glb',
  //     'butterfly1.glb',
  //     'butterfly4.glb',
  //     'cabbageWhite.glb',
  //     'dragonFly.glb',
  //     'fly2.glb',
  //     'greenFlying.glb',
  //     'moth12.glb',
  //     'nightButterfly.glb',
  //     'nightFly.glb',
  //     'nightFly13.glb',
  //     'wasp6.glb',
  //     'whiteButterfly.glb',
  //     'whiteButterfly5.glb',
  //     'yellowInsect.glb'
  // ],
  //------------------------------------> SLITHERING CREATURES
  lastSlitherTypeSpawned: 0,
  slitherCreaturesScale: 3,
  slither_spawnOrigin_min: 3.5,
  slither_spawnOrigin_max: 5,
  slitherLimitX: 7,
  // slither_spawnOrigin_min: 4,
  // slither_spawnOrigin_max: 9,
  // slitherLimitX: 7,
  // activeCreatures_slither: [],
  creatureList_slither: [
    {
      name: 'caterpillar',
      rateOfTravel: 0.0004,
      slitherOrigin: 2.2,
      slitherRate: 0.07,
      slitherRange: 1.5,
      leanRate: 0.25,
    },
    {
      name: 'slug1',
      rateOfTravel: 0.0004,
      slitherOrigin: 2.2,
      slitherRate: 0.07,
      slitherRange: 1.5,
      leanRate: 0.25,
    },
    {
      name: 'snail1',
      rateOfTravel: 0.0004,
      slitherOrigin: 2.2,
      slitherRate: 0.07,
      slitherRange: 1.5,
      leanRate: 0.25,
    },
    {
      name: 'snail2',
      rateOfTravel: 0.0004,
      slitherOrigin: 2.2,
      slitherRate: 0.07,
      slitherRange: 1.5,
      leanRate: 0.25,
    },
  ],

  init: function() {
  },
  setupMaterial: function() {
    if (this.creatureMaterial == null) {
      this.creatureMaterial = MaterialManager.createMaterial('creatureAtlas', AssetLoader.textureAssets['irwn_creatureAtlas.basis'], false, false);
    }
  },

  showNewScene: function() {
    CreatureManager.addRandomSlitherer(0);
    CreatureManager.addRandomSlitherer(1);
    if (Math.random() > 0.5) {
      Component_Slither.active.slither0.entity.setLocalPosition(pc.math.random(-1, 1), -1.6, 1);
    } else {
      Component_Slither.active.slither1.entity.setLocalPosition(pc.math.random(-1, 1), -1.7, 1.1);
    }
    CreatureManager.start_spawnTimer_flyingCreature(0);
    CreatureManager.start_spawnTimer_flyingCreature();
    CreatureManager.start_spawnTimer_flyingCreature();
  },

  addRandomFlyingCreature: function() {
    // which type of creature to spawn?
    let creatureIndex = this.lastFlyingTypeSpawned;
    while (creatureIndex === this.lastFlyingTypeSpawned) {
      creatureIndex = Math.floor(Math.random() * this.creatureList_fly.length);
    }
    const config = this.creatureList_fly[creatureIndex];
    this.lastFlyingTypeSpawned = creatureIndex;

    // add CONTAINER
    const container = new pc.Entity('flyingContainer' + IRWN.uuidv4());
    PlantScene.addChild(container, PlantScene.root);
    container.setLocalScale(0, 0, 0);

    // creature model and FLY component
    const creatureEntity = AssetLoader.modelAssets[config.name].resource.instantiateRenderEntity({});
    creatureEntity.name = 'flying' + IRWN.uuidv4();
    const scl = CreatureManager.flyingCreatureScale * config.scale;
    creatureEntity.setLocalScale(scl, scl, scl);
    container.addChild(creatureEntity);

    const glb = creatureEntity.children[0];
    creatureEntity.slither = Component_Fly.attachToEntity('fly' + IRWN.uuidv4(), container, glb, config);

    // apply material to all meshes
    const mi = glb.render.meshInstances;
    mi.forEach((inst) => {
      inst.material = this.creatureMaterial;
    });

    return creatureEntity;
  },

  start_spawnTimer_flyingCreature(timerMin = 0, timerMax = 10) {
    const delay = pc.math.random(timerMin, timerMax);
    gsap.delayedCall(delay, this.addRandomFlyingCreature, [], CreatureManager);
  },
  killAllSpawnTimers: function() {
    gsap.killTweensOf(this.addRandomFlyingCreature);
  },

  addRandomSlitherer: function(laneIndex) {
    // which type of creature to spawn?
    let creatureIndex = this.lastSlitherTypeSpawned;
    while (creatureIndex === this.lastSlitherTypeSpawned) {
      creatureIndex = Math.floor(Math.random() * this.creatureList_slither.length);
    }
    const config = this.creatureList_slither[creatureIndex];
    this.lastSlitherTypeSpawned = creatureIndex;

    // add CONTAINER
    const container = new pc.Entity('slitherContainer' + laneIndex);
    PlantScene.addChild(container, PlantScene.root);
    container.setLocalScale(0, 0, 0);

    const topLane = laneIndex === 0;
    // lane 0 = -1.7
    // lane 1 = -1.8
    const yPos = topLane ? -1.675 : -1.775;
    const originMin = topLane ? -CreatureManager.slither_spawnOrigin_max : CreatureManager.slither_spawnOrigin_min;
    const originMax = topLane ? -CreatureManager.slither_spawnOrigin_min : CreatureManager.slither_spawnOrigin_max;
    const originX = pc.math.random(originMin, originMax);
    const depth = topLane ? 1 : 1.1;
    container.setLocalPosition(originX, yPos, depth);

    const creatureEntity = AssetLoader.modelAssets[config.name].resource.instantiateRenderEntity({});
    creatureEntity.name = 'slither' + laneIndex;
    creatureEntity.setLocalScale(CreatureManager.slitherCreaturesScale, CreatureManager.slitherCreaturesScale, CreatureManager.slitherCreaturesScale);
    container.addChild(creatureEntity);

    const glb = creatureEntity.children[0];
    creatureEntity.slither = Component_Slither.attachToEntity('slither' + laneIndex, container, glb, laneIndex, config);
    // apply material to all meshes
    const mi = glb.render.meshInstances;
    mi.forEach((inst) => {
      inst.material = this.creatureMaterial;
    });
    return creatureEntity;
  },

  flush: function() {
  },
};
export {CreatureManager};
